$(function() {
  const radios = $('input[name="cash_collection"]');
  if (radios.length === 0) {
    return;
  }

  const partnerSelect = $('select[name="cash_collection_to_branch_id"]');
  const autoTransfer = $('input[name="cash_auto_transfer"]');
  const otherBranchId = $('input[name="cash_collection_other_branch_id"]');
  const otherBranchBlock = $('[data-cash-collection-other-branch]');
  const otherBranchValue = '-1';

  function syncPartnerControls() {
    const toBranch = radios.filter(':checked').val() === 'to_branch';
    const otherBranch = toBranch && partnerSelect.val() === otherBranchValue;

    partnerSelect.prop('disabled', !toBranch);
    autoTransfer.prop('disabled', !toBranch);
    otherBranchId.prop('disabled', !otherBranch);
    otherBranchBlock.toggle(otherBranch);
  }

  radios.on('change', syncPartnerControls);
  partnerSelect.on('change', syncPartnerControls);
  syncPartnerControls();
});
